var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCraftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2599_15021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.95529 13.4184L11.2551 7.91349C11.6368 6.30406 10.8115 4.56136 9.24346 4.0283C7.43811 3.41323 5.52959 4.4896 5.10662 6.29381C5.03441 6.61159 3.35285 13.7464 1.12453 23.3107C-0.247536 29.1846 2.46565 34.2179 7.76823 37.1395C13.0708 40.0611 19.6836 40.1534 23.9648 35.8991L40.801 19.1693C41.8842 18.0929 41.8842 16.3399 40.801 15.2636C39.7178 14.1872 37.9537 14.1872 36.8705 15.2636L38.8409 13.3056C39.9241 12.2292 39.9241 10.4763 38.8409 9.39991C37.7577 8.32354 35.9936 8.32354 34.9104 9.39991L36.8808 7.44194C37.9641 6.36557 37.9641 4.61262 36.8808 3.53625C35.7976 2.45988 34.0335 2.45988 32.9503 3.53625L30.9799 5.49422C32.0631 4.41785 32.0631 2.6649 30.9799 1.58853C29.8967 0.512157 28.1326 0.512157 27.0494 1.58853L16.372 12.1882",
    stroke: "#095E4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.98 5.48438L24.3157 12.1066",
    stroke: "#095E4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9104 9.40039L29.092 15.182",
    stroke: "#095E4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8808 15.2637L30.2681 21.8347",
    stroke: "#095E4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9132 22.542C22.1801 21.2811 19.6732 20.4713 16.6196 20.4713C13.4009 20.4713 11.3686 21.2708 9.718 22.5625C9.10934 21.9679 8.8927 21.2913 8.8927 20.5635C8.8927 18.1442 12.0701 16.1965 16.8363 16.1965C19.1781 16.1965 21.4064 16.7603 23.0982 17.6727C23.5315 17.9085 24.6251 19.0874 24.6251 19.0874L24.3465 17.3344C22.6134 16.0735 19.8899 15.2637 16.8363 15.2637C11.4511 15.2637 7.98486 17.4984 7.98486 20.5635C7.98486 21.5271 8.36657 22.4087 9.06808 23.1673C8.36657 23.9259 7.98486 24.8075 7.98486 25.7711C7.98486 28.8464 11.4511 31.0709 16.8363 31.0709C21.5508 31.0709 24.2537 28.9797 24.3465 28.908L24.6251 27.1243C24.6251 27.1243 23.5315 28.3339 23.0982 28.5697C23.026 28.6107 22.9538 28.6517 22.8713 28.6824C21.3754 29.441 19.2812 30.1176 16.8363 30.1176C12.0701 30.1176 8.8927 28.1699 8.8927 25.7506C8.8927 25.0228 9.11966 24.3359 9.718 23.7414C11.3686 25.0433 13.3906 25.8429 16.6196 25.8429C19.8486 25.8429 22.3452 24.7767 23.9029 23.6901V22.5215L23.9132 22.542ZM16.6299 21.4656C18.9717 21.4656 21.5405 22.2345 23.0982 23.1263C21.6024 24.0387 19.4566 24.869 16.6299 24.869C13.8033 24.869 12.0082 24.2129 10.4711 23.1673C12.0082 22.1217 13.8033 21.4554 16.6299 21.4554V21.4656Z",
    fill: "#095E4D",
    stroke: "#095E4D",
    strokeWidth: 0.46,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2599_15021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.4,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraftIcon);
export default __webpack_public_path__ + "static/media/craft-icon.512e2015d05039440a9b2899396c194a.svg";
export { ForwardRef as ReactComponent };